import { GroupDto } from 'entities/group';

export function getOpenKeys(groups: GroupDto[], groupId: number): string[] {
  const group = groups.find((elem) => elem.id === groupId) as GroupDto;

  if (!group?.parentId) return [String(groupId)];

  return [String(groupId), ...getOpenKeys(groups, group.parentId)];
}
